import StationAdoptStore from "../stationadopt/StationAdoptStore";
import StationsStore from "./StationsStore";
import {
    createNew,
    deleteSingle,
    findById, getCurrentAutoPalletForStation,
    getLastAutoPalletForStation,
    getCurrentPressPallets,
    getPressPalletsBetween,
    save
} from "./PressPalletBuilderStore";
import {getJobsBetween, findByIds} from "./PressJobsStore";
import CheckInStore from "./CheckInStore2";
import _ from 'lodash';
import {firebaseConfig} from "../FIREBASE_CONFIG";
import {saveAs} from "file-saver";
import firebase from "firebase";
import {addLocalTimeStrings} from "../../framework/util/js/DateUtils";


const TYPE_AUTO = 'auto';
const TYPE_MANUAL = 'manual';

class PalletBuilderSuperStore {

    async saveManualPallet(pallet) {

        const loadOperatorInfo = await new CheckInStore().loadDataFromPersonId(pallet.loadOperatorId);
        const unloadOperatorInfo = await new CheckInStore().loadDataFromPersonId(pallet.unloadOperatorId);

        this.addJobCount(pallet);

        const station = await new StationsStore().findById(pallet.stationId);

        pallet.stationInfo = station?.data;
        pallet.loadOperatorInfo = loadOperatorInfo;
        pallet.unloadOperatorInfo = unloadOperatorInfo;
        pallet.loadTimeISO = pallet.loadTime.toISOString();
        pallet.unloadTimeISO = pallet.unloadTime.toISOString();
        pallet.createType = TYPE_MANUAL;
        await save(pallet);

    }

    async getPalletEventsData(stationId, hours, limit) {

        const station = await new StationsStore().findById(stationId);

        var beginningDate = Date.now() - hours * 60 * 60 * 1000;
        var beginningDateObject = new Date(beginningDate);

        const pressJobs = await getJobsBetween(station.data, beginningDateObject, null, limit);
        const pallets = await getPressPalletsBetween(stationId, beginningDateObject, null, limit);

        const data = {
            station: station.data,
            jobs: pressJobs.data,
            pallets: pallets.data
        }

        return data;
    }

    async getStationsOnThisSite() {

        const siteId = await this.getCurrentSiteId();

        const stations = await new StationsStore().findBySiteId(siteId);

        return stations;
    }

    async checkInOperatorAtSite(personId) {
        new CheckInStore().save(personId);
    }

    async getCurrentPallet() {

        const stationId = await new StationAdoptStore().getStationId();

        const pallet = await getCurrentAutoPalletForStation(stationId);

        if (pallet) {
            // Its not current if it has an unload time
            if (pallet.unloadTime)
                return null;

            const refreshed = await this.loadPalletAndFillOutPressJobs(pallet.id);
            return Promise.resolve(refreshed);
        }
        else
            return null;

    }

    async getLastFinishedPallet() {

        const stationId = await new StationAdoptStore().getStationId();

        const pallet = await getLastAutoPalletForStation(stationId);

        if (pallet) {
            // Its not finished if it does not have an unload time
            if (!pallet.unloadTime)
                return null;

            const refreshed = await this.loadPalletAndFillOutPressJobs(pallet.id);
            return Promise.resolve(refreshed);
        }
        else
            return null;

    }

    async getCurrentAndLastPallet() {
        const current = await this.getCurrentPallet();
        const last = await this.getLastFinishedPallet();
        const r = {pallet: current, lastPallet: last};
        return Promise.resolve(r);
    }

    async getPalletForReport(palletId) {
        const pallet = this.loadPalletAndFillOutPressJobs(palletId);
        return pallet;
    }

    async getPalletsForStation() {

        const pallets = this.filterNotFinishedPallets(await getCurrentPressPallets(500));
        return pallets;

    }

    filterNotFinishedPallets(pallets) {
        const r = [];
        pallets.data.forEach((pallet) => pallet.unloadTime && r.push(pallet));
        return r;
    }

    async getCurrentStation() {
        const adoptedStation = await new StationAdoptStore().read();
        if (!adoptedStation?.data?.stationId)
            throw 'Station not assigned!'

        const stationId = adoptedStation.data.stationId;
        const station = await new StationsStore().findById(stationId);
        if (!station?.data)
            throw 'Station not found ' + stationId;
        return station;
    }

    async getCurrentSiteId() {
        const station = await this.getCurrentStation();
        const siteId = station.data.siteId;
        return siteId;
    }

    async cancelPallet(pallet) {
        deleteSingle(pallet);
    }

    async finishPallet(values) {

        var checkInInfo = await new CheckInStore().read();

        // If different person is loading than is checked in
        // Go ahead and check them in
        const checkedInId = checkInInfo ? checkInInfo.data.personId : null;
        if (values.unloadOperatorId != checkedInId) {
            await new CheckInStore().save(values.unloadOperatorId);
            checkInInfo = await new CheckInStore().read();
        }

        // Pull the jobs
        const pallet = await this.getCurrentPallet();
        if (!pallet)
            throw 'No current pallet';
        pallet.unloadOperatorId = values.unloadOperatorId;
        pallet.unloadOperatorInfo = checkInInfo.data;
        pallet.unloadTime = new Date();
        pallet.unloadTimeISO = pallet.unloadTime.toISOString();
        pallet.createType = TYPE_AUTO;
        const cloned = _.clone(pallet);
        await save(pallet);
        pallet.unloadOperatorInfo = checkInInfo;

        return Promise.resolve(cloned);


    }

    async startPallet(values) {
        console.log('Starting a pallet', {values});

        const adoptInfo = await new StationAdoptStore().read();
        var checkInInfo = await new CheckInStore().read();


        // If different person is loading than is checked in
        // Go ahead and check them in
        const checkedInId = checkInInfo ? checkInInfo.data.personId : null;
        if (values.loadOperatorId != checkedInId) {
            await new CheckInStore().save(values.loadOperatorId);
            checkInInfo = await new CheckInStore().read();
        }

        const stationId = adoptInfo.data.stationId;
        const stationInfo = await new StationsStore().findById(stationId);
        const loadTime = new Date();

        const data = {
            palletId: values.palletId,
            stationId: stationId,
            loadTime: loadTime,
            loadTimeISO: loadTime.toISOString(),
            loadOperatorId: values.loadOperatorId,
            stationInfo: stationInfo.data,
            loadOperatorInfo: checkInInfo.data,
            createType: TYPE_AUTO
        };

        const created = await createNew(data);


        const current = this.getCurrentAndLastPallet();

        return Promise.resolve(current);

    }

    async loadCurrentPalletAndFillOutPressJobs() {

        const pallets = await getCurrentPressPallets(1);
        if (!pallets?.data) {
            return null;
        } else if (pallets.data[0].unloadTime) {
            // Pallet is unloaded
            return null;
        } else {
            const palletId = pallets.data[0].id;
            return this.loadPalletAndFillOutPressJobs(palletId);
        }

    }

    async loadCurrentPalletAndFillOutPressJobsWithReject() {

        const pallet = await this.loadCurrentPalletAndFillOutPressJobs();
        if (!pallet) {
            return Promise.reject("No current pallet");
        } else {
            return Promise.resolve({data: pallet});
        }

    }


    async loadPalletAndFillOutPressJobs(palletId) {

        if (!palletId)
            throw 'palletId must be specified';

        const pallet = await findById(palletId);

        if (!pallet)
            throw 'Pallet manifest not found ' + palletId;
        if (!pallet.loadTime)
            throw 'Pallet has no loadTime';

        const endTime = pallet.unloadTime ? pallet.unloadTime : new Date();

        const station = await new StationsStore().findById(pallet.stationId);
        if (!station?.data)
            throw 'Station not found';

        const origJobs = [];
        if (pallet.jobs)
            pallet.jobs.forEach(job=>origJobs.push(job.id));

        var  filledOutJobs;
        if (pallet.createType == TYPE_AUTO)
            filledOutJobs = await getJobsBetween(station.data, pallet.loadTime, endTime, 500);
        else
            filledOutJobs = await findByIds(origJobs);


        pallet.jobs = filledOutJobs.data;

        this.addJobCount(pallet);

        return addLocalTimeStrings(pallet);
    }

    addJobCount = (pallet) =>{
        if (!pallet?.jobs)
            return;

        pallet.jobCount = pallet.jobs.length;
        pallet.spreadCount = 0;
        pallet.sheetCount = 0;
        pallet.sheetsWithQuantity = 0;
        pallet.jobs.forEach((job) => {
            pallet.spreadCount += job.spreads ? job.spreads : 0;
            pallet.sheetCount += job.sheets ? job.sheets : 0;
            pallet.sheetsWithQuantityCount += job.sheetsWithQuantity ? job.sheetsWithQuantity : 0;
        });
    }

    async printManifest(palletId, stationId, saveDesignerData) {

        // Reload the pallet to get the latest data and fully filled out
        // press jobs
        const pallet = await new PalletBuilderSuperStore().loadPalletAndFillOutPressJobs(palletId);

        const station = await new StationsStore().findById(stationId);
        const site = station.data.siteId;
        const stationName = station.data.name;

        const pdfName = site + "__" + stationName + "__" + pallet.id + ".pdf";

        // Refresh the pallet, as reprint does not have the full pallet
        
        
        // Print the manifest
        const report = 'palletManifest';
        const manifestJson = {
            "reportBucket": firebaseConfig.storageBucket,
            "reportPath": "reporttemplates/" + report + ".zip/reportZip",
            "reportNameInZip": report + ".jasper",
            data: pallet
        };
        console.log('Calling print with params', manifestJson);
        const requestOptions = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(manifestJson)
        };
        var blob = new Blob([JSON.stringify(manifestJson.data)], {type: "text/plain;charset=utf-8"});

        saveDesignerData && saveAs(blob, "designerData.json");


        const response = await fetch('/api/jasperReportGeneratorJson', requestOptions);
        if (!response.ok) {
            console.log(response);
            throw 'Failed to fetch: ' + response.statusText;
        }
        const responseBlob = await response.blob();


        // Connect to storage
        var storage = firebase.storage();
        var storageRef = storage.ref();
        var IPTCloudPrintBucket = storageRef.child('IPTCloudPrintOnPrem');
        var manifestRef = IPTCloudPrintBucket.child(pdfName);

        await manifestRef.put(responseBlob);
        // saveAs(blob, 'palletManifest.pdf'));

    }


}

export default PalletBuilderSuperStore;
